(() => {
  'use strict';
  document.querySelectorAll('[data-content-concern]').forEach(section => {
    if (section.dataset.concernInitialized) return;
    section.dataset.concernInitialized = 'true';
    const trigger = section.querySelector('[data-concern-open]');
    const panel = section.querySelector('[data-concern-panel]');
    const close = section.querySelector('[data-concern-close]');
    const heading = section.querySelector('#HaroContentConcernHeading');
    const pageField = section.querySelector('[data-concern-page]');
    const result = section.querySelector('[data-concern-result]');
    if (!trigger || !panel) return;

    const open = focusTarget => {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      if (pageField && !pageField.value) pageField.value = window.location.href.split('#')[0];
      (focusTarget || heading)?.focus();
      panel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    };
    const hide = () => {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    };

    trigger.addEventListener('click', () => open());
    close?.addEventListener('click', hide);
    if (result) open(result);
  });
})();
